import { IJobTitleState } from 'store/types';

export enum JobClassification {
  DIRECT = 'direct',
  INDIRECT = 'indirect',
  NONE = 'none',
}

export enum SiteJobSource {
  SITE = 'site',
  POS = 'pos',
}

export interface IJob {
  title: string;
  classification?: JobClassification;
}

export interface IJobTitlesResponse {
  siteId: string;
  response: IJobTitleState[];
}

export interface IGetJobTitleOptions {
  siteId: string;
  sources?: SiteJobSource[];
}

export interface IGetOrgJobTitleOptions {
  organizationId: string;
  includeInactive?: boolean;
}

export interface IOrgJobTitlesResponse {
  organizationId: string;
  response: IJobTitleState[];
}
